import { logError } from "apis/utilAPIs";
import React from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

 class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
    error: null,
    errorInfo: null,
  };

  componentDidCatch(error, info) {
    this.setState({ hasError: true, error, info });
    try {
      console.error("Error caught by boundary:", error, info);

      const errorMessage = [
        `Error: ${error && error.name ? error.name : "Unknown"}: ${error && error.message ? error.message : "No message"}`,
        `Component stack: ${info && info.componentStack ? info.componentStack : "N/A"}`,
        `Error stack: ${error && error.stack ? error.stack : "N/A"}`,
      ].join("\n");

      const errorData = {
        title: `Order Component Error: ${error && error.name ? error.name : "Unknown"}`,
        message: errorMessage,
      };
      logError(errorData);
    } catch (loggingError) {
      console.log("Error while logging error:", loggingError);
    }
  }

  render() {
    const { hasError, error, errorInfo } = this.state;
    const { fallbackComponent: FallbackComponent, children } = this.props;

    if (hasError) {
      // Render the fallback UI provided by the parent component
      if (FallbackComponent) {
        return <FallbackComponent error={error} errorInfo={errorInfo} />;
      }
      // If no fallback component is provided, render a default error message and reload button to reload the page

      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            gap: 2,
            px: 3,
            textAlign: "center",
          }}
        >
          <Typography variant="h6">
            Something went wrong. Please try reloading the page.
          </Typography>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              variant="outlined"
              onClick={() => window.history.back()}
            >
              Go Back
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => window.location.reload()}
            >
              Reload
            </Button>
          </Box>
        </Box>
      );
    }

    // If no error has occurred, render the children as normal
    return children;
  }
}

export default ErrorBoundary;